import {observer} from "mobx-react-lite"
import React, {useState} from "react"
import {Field, Fields, Select} from "../../lib/wa-2.0"
import controller from "../../store/pageControllers/StockSettingsController"
import {PriceUpdateSettings} from "./PriceUpdateSettings"
import {PriceUpdateLauncher} from "./PriceUpdateLauncher"
import "./priceUpdate.sass"
import PricesHistoryComponent from "./PricesHistoryComponent"
import {Route, useHistory, useLocation} from "react-router-dom"
import {appPages} from "../../App"
import ProductPriceHistoryComponent from "./ProductPriceHistoryComponent"
import classNames from "classnames"


export const PriceUpdatePage = observer(() => {
    // const [currentTab, setCurrentTab] = useState<string>('settings');
    const history = useHistory();
    const location = useLocation();
    const Tabs = [
        {
            path: [appPages.priceSync],
            name: 'Настройки'
        },{
            path: [appPages.priceSync + '/launcher/'],
            name: 'Запуск'
        },{
            path: [
                appPages.priceSync + '/history/',
                appPages.priceSync + '/history/product/',
            ],
            name: 'История'
        },
    ]

    // const classExists = function(pathes: string[], path: string): boolean {
    //     let exist = false
    //     pathes.forEach((val, index) => {
    //         if(val.indexOf(path)) exist = true
    //     })
    //     return exist
    // }

    return <div>
        <h1>Обновление цен</h1>

        <ul className={'ozon_price_tabs'}>
            {Tabs.map((el, index) =>
                <li
                    key={index}
                    onClick={() => history.push(el.path[0])}
                    className={classNames({
                        active: el.path.includes(location.pathname)})}
                >{el.name}</li>
            )}
        </ul>

        <React.Fragment>
            <Route exact path={appPages.priceSync + '/'} component={PriceUpdateSettings}/>
            <Route exact path={appPages.priceSync + '/launcher/'} component={PriceUpdateLauncher}/>
            <Route exact path={appPages.priceSync + '/history/'} component={PricesHistoryComponent}/>
            <Route exact path={appPages.priceSync + '/history/product/:product_id'} component={ProductPriceHistoryComponent}/>

        </React.Fragment>
        {/*{currentTab === 'settings' ?*/}
            {/*<PriceUpdateSettings/>*/}
            {/*: currentTab === 'launch' ?*/}
                {/*<PriceUpdateLauncher/> :*/}
                {/*<PricesHistoryPage/>}*/}
    </div>
})